export const TEAM_URL = "/dataroom/:dataroomId/team/:teamId";
export const IRL_URL = "/dataroom/:dataroomId/irl";
export const DOC_URL = "/dataroom/:dataroomId/documents";
export const NOTE_ID_URL = "/dataroom/:dataroomId/workspace/note/:noteId";